import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("voya_cookie_consent")) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("voya_cookie_consent", "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-slate-900 text-white rounded-3xl shadow-2xl p-5 border border-white/10 animate-fade-up">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-2xl bg-orange-500/20 flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5 text-orange-400" />
        </div>
        <div>
          <p className="text-sm leading-relaxed text-white/90">
            We use cookies to keep you signed in and improve your experience. By using Voyes you agree to our{" "}
            <Link to="/privacy" className="text-orange-400 underline">Privacy Policy</Link> and{" "}
            <Link to="/terms" className="text-orange-400 underline">Terms of Service</Link>.
          </p>
          <div className="flex gap-2 mt-3">
            <Button onClick={accept} data-testid="cookie-accept" className="rounded-full bg-orange-500 hover:bg-orange-600 h-9">Accept</Button>
            <Link to="/privacy">
              <Button variant="ghost" className="rounded-full h-9 text-white/80 hover:text-white hover:bg-white/10">Learn more</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}